import * as Popover from "@radix-ui/react-popover";
import { PlusIcon } from "@radix-ui/react-icons";
import { Auth0AccountRole } from "client/openapi";
import { Button, ButtonColor } from "components/Button";
import { getDialog } from "components/Dashboard/UserListActions/helpers";
import { Dialog } from "components/Dialog";
import { useState } from "react";

const OPTIONS = [
  { label: "Student", role: Auth0AccountRole.ME },
  { label: "Parent", role: Auth0AccountRole.PARENT },
  { label: "Tutor", role: Auth0AccountRole.ORG_TUTOR },
];

/** Invite opens a menu of Student, Parent and Tutor; each opens today's invite dialog. */
export default function InviteMenu({
  orgId,
  refetch,
}: {
  orgId: number;
  refetch: () => void;
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [inviting, setInviting] = useState<Auth0AccountRole | null>(null);

  return (
    <>
      <Popover.Root open={menuOpen} onOpenChange={setMenuOpen}>
        <Popover.Trigger asChild>
          <Button color={ButtonColor.PURPLE}>
            Invite <PlusIcon />
          </Button>
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content
            className="people-panel__menu"
            align="end"
            sideOffset={6}
          >
            {OPTIONS.map(({ label, role }) => (
              <button
                key={role}
                type="button"
                className="people-panel__menu-item"
                onClick={() => {
                  setMenuOpen(false);
                  setInviting(role);
                }}
              >
                {label}
              </button>
            ))}
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>

      {/* Mounted only while open, so every invite starts from an empty form.
          The student dialog links the parent after its own refetch, so
          closing refetches again. */}
      <Dialog
        open={inviting !== null}
        onOpenChange={(open) => {
          if (!open) {
            setInviting(null);
            refetch();
          }
        }}
      >
        {inviting !== null &&
          getDialog({
            type_of_user_being_invited: inviting,
            fetchUsers: refetch,
            currentPage: 0,
            orgId,
          })}
      </Dialog>
    </>
  );
}
